import React, { useEffect, useState } from 'react';
import './style.css';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import DashBoardIcon from '../../assets/images/Home-simple-door-mobile-dashboard.png';
import TraderIcon from '../../assets/images/traders-mobile.png';
import SettingIcon from '../../assets/images/Settings.png';
import WalletIcon from '../../assets/images/wallet.png';
import Educenter from '../../assets/images/educenter.png';
import Support from '../../assets/images/support.png';
import LogoutIcon from '../../assets/images/logout.png';

import {
  DashboardBtnMobile,
  NavBtnCustomStyle,
  NavDashBtn,
  NavIcon,
  NavConnectBtn,
  NavGetStartedBtn,
  NavGetStartedBtnMobile,
  NavIconMobile,
  SideBarList
} from './nav-styles';
import ConnectWallet from '../Modal/ConnectWallet';
import HootdexHeader from './HootdexHeader';
import { Box, Button, Grid, Tab, Tabs } from '@mui/material';
import { api as axios } from '../../api';
import url from '../../serverUrl';
import { ethers } from 'ethers';
import HeaderTab from '../Tables/Exchange/HeaderTab';
import { navTabsList } from './navTabsList';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter, clearAllCookies, getCookie } from '../../utils';
import { MenuData } from '../Tables/menuData';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => ({
  indicator: {
    display: 'none' // Hide the indicator (active color)
  }
}));

const NavElement = ({ e, i, requestAccount }) => {
  const classes = useStyles();
  const { value, label, child, metamask } = e;
  const [showChild, setShowChild] = useState(false);

  if (child && child.length > 0) {
    return (
      <div
        onMouseEnter={() => setShowChild(true)}
        onMouseLeave={() => setShowChild(false)}
      >
        <Tab label={label} key={i} className="headerTab" />
        {showChild && (
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 'fit-content',
              zIndex: 999,
              backgroundColor: 'rgb(19 19 21)',
              width: '96.5px'
            }}
          >
            {' '}
            {child.map((elem, i) => (
              <a href={elem.value} target={'_blank'} rel="noreferrer">
                {' '}
                <Tab label={elem.label} key={i} className="headerTab" />
              </a>
            ))}
          </div>
        )}
      </div>
    );
  }
  if (metamask) {
    return (
      <a href={value}>
        {' '}
        <Tab
          key={i}
          className="headerTab"
          onClick={() => requestAccount()}
          icon={<img src={e.logo} alt={label} width={30} />}
        />
      </a>
    );
  }
  return (
    <a href={value} target={'_blank'} rel="noreferrer">
      {' '}
      <Tab label={label} key={i} className="headerTab" />
    </a>
  );
};
export default function Nav({ fetchWallet, wallet }) {
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const { UserInfo, WalletInfo, isAdmin } = useSelector((state) => state);

  const handleOpen = () => {
    // const redirectUrl = `https://hootdex.net/RedirectAuth?source=app.hootdex.net`;
    // window.location.href = redirectUrl;
    const tokenValue = getCookie('walletToken');
    localStorage.setItem('hootdex_secretcookie_wallet', tokenValue);

    if (tokenValue !== null) {
      window.location.reload();
    } else {
      alert('Wallet not accessible.');
    }
  };

  const [opens, setOpens] = React.useState(false);
  const handleOpens = () => setOpens(true);
  const handleClose = () => setOpen(false);

  const [showSugesstion, setShowSugesstion] = useState(false);
  const [currentValue, setCurrentValue] = useState(null);
  const findUser = async () => {
    if (UserInfo) {
      setUser(UserInfo);
    }
  };
  const get_current_index_coin = () => {
    axios
      .get(`${url}/wallet/get_current_index_coin`)
      .then((res) => {
        setCurrentValue(res.data[0].value);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const get_latest_block = () => {
    axios
      .get(`${url}/wallet/latestSyncedBlock`)
      .then((res) => {
        setBlock(res.data.block_length);
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  const location = useLocation();
  useEffect(() => {
    setUser(null);
    findUser();
    get_current_index_coin();
  }, [location]);

  useEffect(() => {
    findUser();
  }, []);
  const [searchKey, setSearchKey] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    // if (searchKey) {
    //   fetchToken(searchKey);
    // } else fetchToken("all");
  };
  const [loading, setLoading] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [block, setBlock] = useState('');
  const fetchToken = (target) => {
    if (target === 'all') {
      setLoading(true);
      axios
        .get(`${url}/hootdex/available-tokens`)
        .then((res) => {
          setTokens(res.data);

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setLoading(true);
      setTokens(tokens.filter((each) => each.symbol === target));
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchToken('all');
    get_latest_block();
  }, []);
  const [showMore, setShowMore] = useState(false);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [showMenu, setShowMenu] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [privateKey, setPrivateKey] = useState(null);
  const [connButtonText, setConnButtonText] = useState('Connect Wallet');
  const [selectedTab, setSelectedTab] = useState(0);
  const requestAccount = () => {
    if (window.ethereum) {
      window.ethereum
        .request({
          method: 'eth_requestAccounts'
        })
        .then((result) => {
          if (result && result[0]) {
            alert(JSON.stringify(`MetaMask is connected`));
            accountChangeHandler(result[0]);
          }
        });
    } else {
      setErrorMessage('Install MetaMask');
    }
  };
  const accountChangeHandler = (newAccount) => {
    setDefaultAccount(newAccount);
    getUserBalance(newAccount);
    getPrivateKey(newAccount);
    // console.log(newAccount, 'newAccount');
  };
  const getUserBalance = (address) => {
    window.ethereum
      .request({
        method: 'eth_getBalance',
        params: [address.toString(), 'latest']
      })
      .then((balance) => {
        setUserBalance(ethers.formatEther(balance));
        // console.log(balance, 'balance');
      });
  };
  const getPrivateKey = (key) => {
    window.ethereum
      .request({
        method: 'eth_privateKeyToAccount',
        params: [key, 'latest']
      })
      .then((keys) => {
        setPrivateKey(keys);
        // console.log(keys, 'keys');
      });
  };

  const [time, setTime] = useState(new Date().toLocaleTimeString());
  useEffect(() => {
    setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000);
  }, []);

  const HandleShow = () => {
    if (showMenu) {
      setShowMenu((old) => !old);
    }
  };
  const closeMenu = () => {
    setShowMenu((old) => !old);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const menu = document.getElementById('your-menu-id');
      if (menu && !menu.contains(event.target) && showMenu) {
        closeMenu();
      }
    };
    document.body.addEventListener('click', handleOutsideClick);
    return () => {
      document.body.removeEventListener('click', handleOutsideClick);
    };
  }, [showMenu]);

  const LastSyncBlockDiv = {
    width: '100vw',
    height: '160px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '20px'
  };
  const BlockSync = {};
  const PecuPrice = {};
  const ContainerWrapper = {
    display: 'flex',
    justifyContent: 'space-around',
    gap: '20px',
    bordeRadius: '40px',
    background: '#1C2B24',
    borderRadius: '40px',
    background: '#1C2B24',
    padding: '20px',
    fontSize: { xs: '14px', sm: '15px', md: '17px', lg: '20px' },
    flexWrap: 'wrap'
  };
  const NavDash = {
    color: '#AEB3BC',
    fontFeatureSettings: 'salt on, liga off',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  };
  return (
    <>
      {/* Floating mint header shared with hootdex.com / hootdex.net.
          Replaces the old desktop bar, mobile bar and slide-out menu. */}
      <HootdexHeader
        walletConnected={Boolean(WalletInfo)}
        onConnect={handleOpen}
        onDisconnect={() => clearAllCookies()}
      />
      {/* <Box sx={LastSyncBlockDiv}>
        <Box sx={ContainerWrapper}>
          <Box sx={BlockSync}>
            Latest synced block:{' '}
            <span style={{ color: '#22BD86' }}>{block}</span>
          </Box>
          <Box sx={PecuPrice}>
            {' '}
            PECU PRICE :
            <span style={{ color: '#22BD86' }}>
              {' '}
              {currentValue?.toFixed(5).toLocaleString('en-US')} USD
            </span>{' '}
          </Box>
        </Box>

        <Box>
          <Box sx={NavDash}>
            <img
              src={require('../../assets/images/Home-simple-door-mobile-dashboard.png')}
              alt="HootDex"
            />
            <span>{`Dashboard > `}</span>
            <span style={{ color: '#76C8A8', fontSize: '19px' }}>
              {MenuData?.find((e) => e.path === location?.pathname)?.label ||
                location?.pathname?.split('')?.map((e, i) => (i > 0 ? e : ''))}
            </span>
          </Box>
        </Box>
      </Box> */}
      <ConnectWallet
        setOpen={setOpen}
        open={open}
        fetchWallet={fetchWallet}
        wallet={WalletInfo}
        setWalletAddress={setWalletAddress}
        requestAccount={requestAccount}
        walletAddress={walletAddress}
        privateKey={privateKey}
      />
    </>
  );
}
